export const PAYEE_TYPE_PAYDM_MERCHANT = "PAYDM_MERCHANT"

export const PAYEE_ERROR_TYPE_TRANSACTION_LIMIT_EXCEEDED = "TRANSACTION_LIMIT_EXCEEDED"
export const PAYEE_ERROR_TYPE_MONTHLY_LIMIT_EXCEEDED = "MONTHLY_LIMIT_EXCEEDED"

export const PAYEE_TRANSACTION_FEE_SETTINGS_ID = '--transaction-fee--'